import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';
import { getRequestById } from '../../../../redux/actions/request';
import { selectIncentiveRequestDetails } from '../../../../redux/selectors/request';
import { StateType } from '../../../../types';

const mapStateToProps = (state: StateType) => ({
  requestDetails: selectIncentiveRequestDetails(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getRequestById,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
